export * from "./AddressResponse";
export * from "./MultipleTextFieldsResponse";
export * from "./QuizResponse";
export * from "./TextResponse";
